import React from "react";
import {
	AutocompleteInput,
	Filter as RaFilter,
	ReferenceInput,
} from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import { useFiltersStyles } from "../components/lists/useStyles";

const Filters = (props) => {
	const classes = useFiltersStyles();
	return (
		<RaFilter {...props} classes={classes}>
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				alwaysOn
				fullWidth
				variant="outlined"
				{...bookmakersConfig.reference}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
		</RaFilter>
	);
};
export default Filters;
